export const FACULTY_LIST_MODIFICATION = 'facultyListModification';
export const USER_LIST_MODIFICATION = 'userListModification';
export const QUEUE_LIST_MODIFICATION = 'queueListModification';
export const HTTP_ERROR_OCCURRED = 'httpErrorOccurred';
export const ALERTS_CHANGED = 'alertsChanged';
export const AUTHENTICATION_SUCCESS = 'authenticationSuccess';
export const UPDATE_PACKAGES_LIST_MODIFICATION = 'updatePackagesListModification';



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/constants/subscription.constants.ts